var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4861 2.04729C21.0105 1.53914 22.4608 2.98944 21.9527 4.51386L16.8961 19.6837C16.3624 21.2846 14.1852 21.4979 13.351 20.0309L10.3347 14.7263L13.3162 11.7447C13.6091 11.4518 13.6091 10.9769 13.3162 10.684C13.0233 10.3911 12.5485 10.3911 12.2556 10.684L9.27408 13.6655L3.96907 10.6489C2.50213 9.8148 2.71539 7.63753 4.31631 7.10389L19.4861 2.04729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.8341a4aad711c43edfb1aba228ceb52c.svg";
export { ForwardRef as ReactComponent };